module.exports = require('./_global');


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/_path.js
// module id = ../node_modules/core-js/modules/_path.js
// module chunks = 1